import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="request" id="request"></a>
    <h1 {...{
      "id": "windowrequest"
    }}>{`window.Request`}</h1>
    <p>{`Request class represents a resource request.`}</p>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <a name="new-request-new" id="new-request-new"></a>
    <h2 {...{
      "id": "requestinput-options"
    }}>{`Request(input, options)`}</h2>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` If options.body exists and options.method is either "GET" or "HEAD".`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`input`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Request`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Defines the resource that you wish to fetch. This can either be:          A string containing the URL of the resource you want to fetch.          A Request object.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`'(Optional)' object containing any custom settings that you want to apply to the request.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.method`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Request method. The default is "GET".`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.headers`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Headers`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any headers you want to add to your request.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.body`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Blob`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`ArrayBuffer`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`TypedArray`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`FormData`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`ReadableStream`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`URLSearchParams`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any body that you want add to your request.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.credentials`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Request credentials you want to use for the request. Either "omit" or "include".`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.signal`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`AbortSignal`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`AbortSignal object which can be used to abort a request.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="request-body" id="request-body"></a>
    <h2 {...{
      "id": "body--readablestream"
    }}>{`body : `}<inlineCode parentName="h2">{`ReadableStream`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
ReadableStream object with the body contents that have been added to the request or null if body is null.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Request/body"
      }}>{`Request - body`}</a>{`  `}</p>
    <a name="request-bodyused" id="request-bodyused"></a>
    <h2 {...{
      "id": "bodyused--boolean"
    }}>{`bodyUsed : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Indicates whether the request body has been read yet.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Request/bodyUsed"
      }}>{`Request - bodyUsed`}</a>{`  `}</p>
    <a name="request-credentials" id="request-credentials"></a>
    <h2 {...{
      "id": "credentials--string"
    }}>{`credentials : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Indicates whether the user agent should send or receive cookies. Possible values are:`}</p>
    <pre><code parentName="pre" {...{}}>{` "omit": Never send or receive cookies.
 "include": Always send cookies.
`}</code></pre>
    <a name="request-headers" id="request-headers"></a>
    <h2 {...{
      "id": "headers--headers"
    }}>{`headers : `}<inlineCode parentName="h2">{`Headers`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
`}<a parentName="p" {...{
        "href": "./Headers.md"
      }}>{`Headers`}</a>{` object associated with the request.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Request/headers"
      }}>{`Request - headers`}</a>{`  `}</p>
    <a name="request-method" id="request-method"></a>
    <h2 {...{
      "id": "method--string"
    }}>{`method : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Request's method. Possible values are "GET", "POST", "HEAD", "PUT", "DELETE" and "OPTIONS".`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Request/method"
      }}>{`Request - method`}</a>{`  `}</p>
    <a name="request-url" id="request-url"></a>
    <h2 {...{
      "id": "url--string"
    }}>{`url : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
URL of the request.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Request/url"
      }}>{`Request - url`}</a>{`  `}</p>
    <a name="request-arraybuffer" id="request-arraybuffer"></a>
    <h2 {...{
      "id": "arraybuffer"
    }}>{`arrayBuffer()`}</h2>
    <p>{`Reads the request body and returns it as a Promise that resolves with an ArrayBuffer.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<ArrayBuffer>`}</inlineCode>{` Promise that resolves with an ArrayBuffer.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Request/arrayBuffer"
      }}>{`Request - arrayBuffer`}</a>{`  `}</p>
    <a name="request-blob" id="request-blob"></a>
    <h2 {...{
      "id": "blob"
    }}>{`blob()`}</h2>
    <p>{`Reads the request body and returns it as a Promise that resolves with a Blob.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Blob>`}</inlineCode>{` Promise that resolves with a Blob.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Request/blob"
      }}>{`Request - blob`}</a>{`  `}</p>
    <a name="request-clone" id="request-clone"></a>
    <h2 {...{
      "id": "clone"
    }}>{`clone()`}</h2>
    <p>{`Creates a copy of the current request object.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Request`}</inlineCode>{` - Copy of the request.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Request/clone"
      }}>{`Request - clone`}</a>{`  `}</p>
    <a name="request-formdata" id="request-formdata"></a>
    <h2 {...{
      "id": "formdata"
    }}>{`formData()`}</h2>
    <p>{`Reads the request body and returns it as a Promise that resolves with a FormData.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<FormData>`}</inlineCode>{` Promise that resolves with a FormData.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Request/formData"
      }}>{`Request - formData`}</a>{`  `}</p>
    <a name="request-json" id="request-json"></a>
    <h2 {...{
      "id": "json"
    }}>{`json()`}</h2>
    <p>{`Reads the request body and returns it as a Promise that resolves with the result of parsing the body text as JSON.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Object>`}</inlineCode>{` Promise that resolves to JSON object.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Request/json"
      }}>{`Request - json`}</a>{`  `}</p>
    <a name="request-text" id="request-text"></a>
    <h2 {...{
      "id": "text"
    }}>{`text()`}</h2>
    <p>{`Reads the request body and returns it as a Promise that resolves with a String decoded using UTF-8.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<string>`}</inlineCode>{` Promise that resolves with a String.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Request/text"
      }}>{`Request - text`}</a>{`  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      